"use client";

import React from "react";
import { useEffect, useState } from "react";
// import { Link } from 'react-router-dom';
// import { HomeDetail } from "../services/HomeDetail";
import Link from "next/link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Keyboard, Mousewheel } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { useDispatch } from "react-redux";
import {
  setInquiryPopup,
  setInquiryPopupObj,
} from "@/store/slices/inquirySlice";
import Image from "next/image";
// import Seo from "../components/Seo";

export default function Home({
  // inquiryPopupObj,
  // setInquiryPopupObj,
  // inquiryPopup,
  // setInquiryPopup,
  homeDetailsData,
  propertylist,
  completedPropertylist,
}) {
  const [isMobilescreen, setMobileScreen] = useState(false);
  //   const [homeDetailsData, setHomeDetail] = useState(homeDetails || null);

  const dispatch = useDispatch();
  useEffect(() => {
    if (window.innerWidth <= 991) {
      setMobileScreen(true);
    }
    // if (!homeDetailsData) {

    // }
  }, []);

  const seoMetaData = homeDetailsData && {
    page_title:
      homeDetailsData.page_title ||
      "Swati Procon - Luxury Residential & Commercial Projects in Ahmedabad",
    page_description:
      homeDetailsData.page_description ||
      "Discover premium residential and commercial projects by Swati Procon, designed with innovation, quality, and sustainability in mind. Explore our ongoing, upcoming, and completed projects in Ahmedabad.",
    page_keywords:
      homeDetailsData.page_keywords ||
      "Swati Procon, luxury apartments, commercial spaces, real estate Ahmedabad, premium projects, residential buildings, office spaces, retail spaces",
    slug: "/",
    image: homeDetailsData.page_image_full
      ? homeDetailsData.page_image_full.includes("?")
        ? `${homeDetailsData.page_image_full}&w=1280&h=640`
        : `${homeDetailsData.page_image_full}?w=1280&h=640`
      : "/images/sswati-procon.png",
  };

  if (!homeDetailsData) {
    return <div>Error loading data</div>;
  }

  const homeBannerData = [
    {
      image: "/images/home-banner/swati-Web-Banners_Trinity.jpg",
      imageMob: "/images/home-banner/swati-mobile-Web-Banners_Trinity.jpg",
      slug: "/Swati-Trinity",
    },
    {
      image: "/images/home-banner/swati-Web-Banners_Signia.jpg",
      imageMob: "/images/home-banner/swati-Web-Banners_Signia-mob.jpeg",
      slug: "/Swati-Signia",
    },
    {
      image: "/images/home-banner/swati-web-Banners_Swati_18.jpg",
      imageMob: "/images/home-banner/swati-web-Banners_Swati_18-mob.jpeg",
      slug: "/Swati-18",
    },
    {
      image: "/images/home-banner/swati-Web-Banners_premier.jpg",
      imageMob: "/images/home-banner/swati-mobile-Web-Banners_premier.jpg",
      slug: "/Swati-Premier",
    },
  ];
  const interleaveOffset = 0.5;
  return (
    <>
      {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}

      <div
        className="reecosys-template-page-wrapper"
        id="home-page-wrapper-reecosys-template"
        style={{ minHeight: "100vh" }}
      >
        <section
          id="home-banner-section-1"
          className="overflow_section piramyd-banner-section relative pt0"
        >
          <div className="banner-swiper homeBannerSwiper relative ">
            {homeBannerData.length > 0 && (
              <Swiper
                modules={[Pagination, Autoplay, Keyboard, Mousewheel]}
                loop={true}
                speed={1000}
                watchSlidesProgress={true}
                grabCursor={false}
                // mousewheel={true}
                keyboard={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                pagination={{
                  el: ".swiper-pagination.homeSwiperPagination",
                  clickable: true,
                }}
                onProgress={(swiper) => {
                  swiper.slides.forEach((slide) => {
                    const slideProgress = slide.progress;
                    const innerOffset = swiper.width * interleaveOffset;
                    const innerTranslate = slideProgress * innerOffset;

                    const inner = slide.querySelector(".slide-inner");
                    if (inner) {
                      inner.style.transform = `translate3d(${innerTranslate}px,0,0)`;
                    }
                  });
                }}
                onTouchStart={(swiper) => {
                  swiper.slides.forEach((slide) => {
                    slide.style.transition = "";
                  });
                }}
                onSetTransition={(swiper, speed) => {
                  swiper.slides.forEach((slide) => {
                    slide.style.transition = `${speed}ms`;
                    const inner = slide.querySelector(".slide-inner");
                    if (inner) {
                      inner.style.transition = `${speed}ms`;
                    }
                  });
                }}
                className="bannerAnimation"
              >
                {homeBannerData.map((data, index) => (
                  <SwiperSlide key={index}>
                    <Link href={`${data.slug}`}>
                      <div className="bannerCard">
                        <div
                          className=" relative slide-inner hide-tab-mobile"
                          style={{
                            backgroundImage: `url(${data.image})`,
                          }}
                        ></div>

                        {/* Mobile */}
                        <div
                          className=" relative slide-inner visible-tab-mobile"
                          style={{
                            backgroundImage: `url(${data.imageMob})`,
                          }}
                        ></div>
                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

            <div className="swiper-pagination homeSwiperPagination"></div>
          </div>
        </section>

        <section
          className="reecosys-template-section section-padding pb0 relative"
          id="reecosys-template-home-section-2"
        >
          <div className="main-container">
            <div className="grid-80">
              <div className="inner-flex inner-flex-medium">
                {homeDetailsData?.home_overview && (
                  <div className="section-paragraph">
                    <p
                      data-aos="fade-in"
                      data-aos-delay="300"
                      data-aos-duration="1000"
                    >
                      {homeDetailsData.home_overview}
                    </p>
                  </div>
                )}
                {homeDetailsData?.highlights_array?.length > 0 && (
                  <div className="highlights-for-homes">
                    <div
                      className="highlights-grid inner-flex inner-flex-smallest"
                      data-aos="fade-in"
                      data-aos-delay="300"
                      data-aos-duration="1000"
                    >
                      {homeDetailsData.highlights_array.map((data, index) => (
                        <div key={index}>
                          <div className="banner-title">
                            <h2>{data.name}</h2>
                          </div>
                          <div className="section-paragraph">
                            <p className="primary-color">{data.tag_line}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {/* hide-tab-mobile */}
                <div className="">
                  <div
                    className={`about-btn-home outline-div-button button-div ${isMobilescreen ? "" : "wfc"} `}
                  >
                    <Link href="/about-us">
                      <div
                        data-aos="fade-in"
                        data-aos-delay="300"
                        data-aos-duration="1000"
                      >
                        <button className="reecosys-template-button button-style-secondary w100">
                          <p>Know More</p>
                        </button>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {propertylist.length > 0 && (
          <section
            className="reecosys-template-section section-padding relative"
            id="reecosys-template-home-section-3"
          >
            <div className="list-grid-block main-container active">
              <div className="inner-flex inner-flex-medium">
                <div className="inner-flex inner-flex-medium">
                  <div className="tab-projects-flex-wrapper">
                    <div className="section-title wfc  relative">
                      <h2
                        className="uppercase "
                        data-aos="fade-in"
                        data-aos-delay="300"
                        data-aos-duration="1000"
                      >
                        Ongoing
                      </h2>
                    </div>
                  </div>
                  <div className="project-list-grid project-list-grid-2-column">
                    {propertylist
                      .filter(
                        (project_list_data) =>
                          project_list_data.status !== "pre launching",
                      )
                      .map((project_list_data, index) => (
                        <div key={index} className="project-list-card relative">
                          <div
                            className="relative"
                            data-aos="fade-up"
                            data-aos-delay="400"
                            data-aos-duration={`${index + 3}00`}
                          >
                            <Link
                              href={project_list_data.slug}
                              className="inner-flex"
                            >
                              <div className="relative">
                                {project_list_data?.banner_data
                                  ?.image_web_type === "image" && (
                                  <div
                                    className="project-img-list overflow relative"
                                    style={{ aspectRatio: "1080 / 844" }}
                                  >
                                    <Image
                                      src={`${project_list_data.banner_data.image_web_full}&h=844&w=1080&q=100`}
                                      alt={
                                        project_list_data.project_title ||
                                        "project"
                                      }
                                      fill
                                      className=""
                                      unoptimized
                                    />

                                    {project_list_data.status && (
                                      <div
                                        className={`status-lable status-${project_list_data.status
                                          .toLowerCase()
                                          .replace(/\s+/g, "-")
                                          .replace(/[^a-z0-9-]/g, "")}`}
                                      >
                                        <p className="text-uppercase">
                                          {project_list_data.status}
                                        </p>
                                      </div>
                                    )}

                                    {/* <div className="animationOverlay"></div> */}
                                  </div>
                                )}
                              </div>

                              <div className="project-info-list">
                                <div className="inner-flex inner-flex-smallest">
                                  <div className="section-paragraph flex-row j-c-sb alc">
                                    <h2 className="text-uppercase charter_regular">
                                      {project_list_data.project_title}
                                    </h2>
                                  </div>

                                  <div className="flex-row alc j-c-sb">
                                    <div className="flex-row alc flex-mb-clm inner-flex-smallest projectHomeSpecs">
                                      {project_list_data.size_price && (
                                        <div
                                          className={`project-information-div flex-row alc inner-flex-smallest ${
                                            isMobilescreen ? "w100" : ""
                                          }`}
                                        >
                                          <div className="building-icon common-icon">
                                            <img
                                              src="/images/icon/building.svg"
                                              alt="reecosys"
                                            />
                                          </div>
                                          <div className="section-textpara banner-detail-row-grid-text">
                                            <p className="capitalize ellipsis-1">
                                              {project_list_data.size_price}
                                            </p>
                                          </div>
                                        </div>
                                      )}

                                      {project_list_data.location && (
                                        <div
                                          className={`project-information-div flex-row alc inner-flex-smallest ${
                                            isMobilescreen ? "w100" : ""
                                          }`}
                                        >
                                          <div className="building-icon common-icon">
                                            <img
                                              src="/images/icon/location.svg"
                                              alt="reecosys"
                                            />
                                          </div>
                                          <div className="section-textpara">
                                            <p className="capitalize ellipsis-1">
                                              {project_list_data.location}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>

                            <div className="projectListingBtn">
                              <button
                                className={`reecosys-template-button button-style-secondary ${
                                  isMobilescreen ? "w100" : ""
                                }`}
                                onClick={() => {
                                  (dispatch(setInquiryPopup(true)),
                                    dispatch(setInquiryPopupObj(project)));
                                }}  
                              >
                                <span className="material-symbols-outlined">
                                  chat
                                </span>
                                <p className="capitalize">Inquire Now</p>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                <div className="inner-flex inner-flex-medium">
                  <div className="tab-projects-flex-wrapper">
                    <div className="section-title section-padding-small pb0 wfc  relative">
                      <h2
                        className="uppercase "
                        data-aos="fade-in"
                        data-aos-delay="300"
                        data-aos-duration="1000"
                      >
                        Completed
                      </h2>
                    </div>
                  </div>
                  <div className="project-list-grid project-list-grid-2-column">
                    {completedPropertylist
                      .filter(
                        (project_list_data) =>
                          project_list_data.status !== "pre launching",
                      )
                      .map((project_list_data, index) => (
                        <div key={index} className="project-list-card relative">
                          <div
                            className="relative"
                            data-aos="fade-up"
                            data-aos-delay="400"
                            data-aos-duration={`${index + 3}00`}
                          >
                            <Link
                              href={project_list_data.slug}
                              className="inner-flex"
                            >
                              <div className="relative">
                                {project_list_data?.banner_data
                                  ?.image_web_type === "image" && (
                                  <div
                                    className="project-img-list overflow relative"
                                    style={{ aspectRatio: "1080 / 844" }}
                                  >
                                    <Image
                                      src={`${project_list_data.banner_data.image_web_full}&h=844&w=1080&q=100`}
                                      alt={
                                        project_list_data.project_title ||
                                        "project"
                                      }
                                      fill
                                      className=""
                                      unoptimized
                                    />

                                    {project_list_data.status && (
                                      <div
                                        className={`status-lable status-${project_list_data.status
                                          .toLowerCase()
                                          .replace(/\s+/g, "-")
                                          .replace(/[^a-z0-9-]/g, "")}`}
                                      >
                                        <p className="text-uppercase">
                                          {project_list_data.status}
                                        </p>
                                      </div>
                                    )}

                                    {/* <div className="animationOverlay"></div> */}
                                  </div>
                                )}
                              </div>

                              <div className="project-info-list">
                                <div className="inner-flex inner-flex-smallest">
                                  <div className="section-paragraph flex-row j-c-sb alc">
                                    <h2 className="text-uppercase charter_regular">
                                      {project_list_data.project_title}
                                    </h2>
                                  </div>

                                  <div className="flex-row alc j-c-sb">
                                    <div className="flex-row alc flex-mb-clm inner-flex-smallest projectHomeSpecs">
                                      {project_list_data.size_price && (
                                        <div
                                          className={`project-information-div flex-row alc inner-flex-smallest ${
                                            isMobilescreen ? "w100" : ""
                                          }`}
                                        >
                                          <div className="building-icon common-icon">
                                            <img
                                              src="/images/icon/building.svg"
                                              alt="reecosys"
                                            />
                                          </div>
                                          <div className="section-textpara banner-detail-row-grid-text">
                                            <p className="capitalize ellipsis-1">
                                              {project_list_data.size_price}
                                            </p>
                                          </div>
                                        </div>
                                      )}

                                      {project_list_data.location && (
                                        <div
                                          className={`project-information-div flex-row alc inner-flex-smallest ${
                                            isMobilescreen ? "w100" : ""
                                          }`}
                                        >
                                          <div className="building-icon common-icon">
                                            <img
                                              src="/images/icon/location.svg"
                                              alt="reecosys"
                                            />
                                          </div>
                                          <div className="section-textpara">
                                            <p className="capitalize ellipsis-1">
                                              {project_list_data.location}
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>

                            <div className="projectListingBtn">
                              <button
                                className={`reecosys-template-button button-style-secondary ${
                                  isMobilescreen ? "w100" : ""
                                }`}
                                 onClick={() => {
                                  (dispatch(setInquiryPopup(true)),
                                    dispatch(setInquiryPopupObj(project)));
                                }}  
                              >
                                <span className="material-symbols-outlined">
                                  chat
                                </span>
                                <p className="capitalize">Inquire Now</p>
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="view-all-projects-btn-home">
                <Link href="/projects">
                  <button className="reecosys-template-button button-style-secondary">
                    <p>View All</p>
                  </button>
                </Link>
              </div>
            </div>
          </section>
        )}

        <section
          className="section-padding"
          style={{ backgroundColor: "#2e2f2f" }}
        >
          <div className="section-title section-padding-small pt0">
            <h2 className="white-color text-center">Social Initiative</h2>
          </div>
          <div className="socialInitiativeImg overflow">
            <img
              loading="lazy"
              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/home/initiative.svg"
              className="hide-tab-mobile"
              alt="Social Initiative Image"
            />
            <img
              loading="lazy"
              src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/home/initiative-mob.svg"
              className="visible-tab-mobile"
              alt="Social Initiative Image"
            />
          </div>
        </section>
      </div>
    </>
  );
}
